import { render, staticRenderFns } from "./Loginpage.vue?vue&type=template&id=acfee492&scoped=true"
import script from "./Loginpage.vue?vue&type=script&lang=js"
export * from "./Loginpage.vue?vue&type=script&lang=js"
import style0 from "./Loginpage.vue?vue&type=style&index=0&id=acfee492&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acfee492",
  null
  
)

export default component.exports